import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.router';
import { UiSwitchModule } from 'ngx-ui-switch';
import { AgmCoreModule } from '@agm/core';
import { ChartsModule } from 'ng2-charts';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { Ng2OrderModule } from 'ng2-order-pipe';
import { Select2Module } from 'ng2-select2';
import { SelectModule } from 'ng2-select';
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';

//#region bootstrap
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
//#endregion

//#region modules
import { DashboardModule } from './dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
//#endregion

import { AppComponent } from './app.component';
import {
    CheckPlateComponent, DashboardComponent, DashboardMapComponent,
    FineDetailsComponent, FinesComponent, FinesChartComponent,
    HotelsComponent, HotelAddComponent, HotelDetailsComponent,
    LoginHotelComponent, ParkingLotsComponent,
    ParkingAddComponent,
    PaymentsComponent, PaymentsChartComponent,
    ProductsComponent, ProductAddComponent,
    SensorsComponent, SupervisorComponent, SupervisorAddComponent,
    SupervisorsComponent, SupervisorCheckedCarsComponent, SupervisorFinesComponent,
    TagsInputComponent, UserComponent, UsersComponent,
    UserFinesComponent, UserPaymentsComponent, UsersChartComponent,
    VehicleChecksComponent,

    DropdownComponent,
    DynamicMapComponent, ImagePreviewComponent,
    IncomingsTableComponent,
    PaginationComponent, SortComponent
} from './components';

import { InstitutionsComponent } from './components/institutions/institutions.component';
import { TownHallsPoliceComponent } from './components/town-halls-police/town-halls-police.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AddLotComponent } from './components/add-lot/add-lot.component';
import { LoginComponent } from './components/login/login.component';
import { SupervisorsChartComponent } from './components/supervisors-chart/supervisors-chart.component';
import { RegisteredLotsChartComponent } from './components/registered-lots-chart/registered-lots-chart.component';
import { AddInstitutionsComponent } from './components/add-institutions/add-institutions.component';
import { SettingsListComponent } from './components/settings-list/settings-list.component';
import { SensorHistoryComponent } from './components/sensor-history/sensor-history.component';
import { AddTownhallComponent } from './components/add-townhall/add-townhall.component';
import { ParkingLotDetailComponent } from './components/parking-lot-detail/parking-lot-detail.component';

import { AuthService } from './service/main/auth.service';
import { AuthGuardService } from './service/main/auth-guard.service';
import { UserResolveService } from './service/main/user-resolve.service';
import { SettingsListService } from './service/main/settings-list.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { MapService } from './service/main/map.service';
import { AddLotService } from './service/main/add-lot.service';
import { AddSupervisorService } from './service/main/add-supervisor.service';
import { CryptoHashService } from './service/common/crypto-hash.service';
import { PaymentResolveService } from './service/main/payment-resolve.service';
import { SupervisorsService } from './service/main/supervisors.service';
import { SupervisorService } from './service/main/supervisor.service';
import { SupervisorResolverService } from './service/main/supervisor-resolver.service';
import { GetAddressService } from './service/main/get-address.service';
import { ToastrService } from './service/common/toastr.service';
import { AddInstitutionService } from './service/main/add-institution.service';
import { InstitutionsService } from './service/main/institutions.service';
import { ParkingResolverService } from './service/main/parking-resolver.service';
import { TownHallsService } from './service/main/town-halls.service';
import { FinesService } from './service/main/fines.service';
import { FineResolverService } from './service/main/fine-resolver.service';
import { ProductsService } from './service/main/products.service';
import { SensorHistoryResolverService } from './service/main/sensor-history-resolver.service';

import {
    HotelAuthGuardService,
    HotelService, HotelResolverService,
    PaginationService,
    ParkingsService, PaymentsService,
    LoginGuardService,
    UsersService, SettingsService, ReservationsService
} from './service';

import { AgmJsMarkerClustererModule, ClusterManager } from "@agm/js-marker-clusterer";

import { FilterByTagsPipe } from './pipes/filter/filter-by-tags.pipe';
import { VehicleCheckDetailsComponent } from './components/vehicle-check-details/vehicle-check-details.component';
import { VehicleCheckResolverService } from './service/main/vehicle-check-resolver.service';
import { FindUserComponent } from './components/find-user/find-user.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        CheckPlateComponent,
        LoginComponent,
        DashboardComponent, DashboardMapComponent,
        UsersComponent,
        AddLotComponent,
        PaymentsComponent,
        FinesComponent,
        HotelsComponent,
        HotelAddComponent,
        HotelDetailsComponent,
        ParkingAddComponent,
        ParkingLotsComponent,
        InstitutionsComponent,
        TownHallsPoliceComponent,
        SupervisorsComponent,
        HeaderComponent,
        SidebarComponent,
        PaymentsChartComponent,
        UsersChartComponent,
        SupervisorsChartComponent,
        RegisteredLotsChartComponent,
        FinesChartComponent,
        UserComponent,
        FindUserComponent,
        SupervisorAddComponent,
        SupervisorComponent,
        AddInstitutionsComponent,
        AddTownhallComponent,
        ParkingLotDetailComponent,
        SettingsListComponent,
        SensorHistoryComponent,
        FineDetailsComponent,
        FilterByTagsPipe,
        ProductAddComponent,
        ProductsComponent,
        SupervisorCheckedCarsComponent,
        SupervisorFinesComponent,
        UserFinesComponent,
        UserPaymentsComponent,
        VehicleChecksComponent,
        VehicleCheckDetailsComponent,
        SensorsComponent, TagsInputComponent, LoginHotelComponent,

        DropdownComponent,
        DynamicMapComponent, ImagePreviewComponent,
        IncomingsTableComponent,
        PaginationComponent, SortComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        HttpClientModule,
        routes,
        ChartsModule,
        NgxPaginationModule,
        Ng2FilterPipeModule,
        Select2Module,
        Ng2OrderModule,
        SelectModule,
        ReactiveFormsModule,
        MyDateRangePickerModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCJ1K72c13M2V1gqxL3aJ2dUzJxOusgO_8',
            libraries: ['places'],
            language: 'ro',
            region: 'RO'
        }),
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (HttpLoaderFactory),
                deps: [HttpClient]
            }
        }),
        UiSwitchModule,
        SharedModule,
        DashboardModule,
        AgmJsMarkerClustererModule
    ],
    providers: [
        AuthService, AuthGuardService, SettingsService,
        UsersService, UserResolveService, MapService, PaymentsService, AddLotService,
        AddSupervisorService, CryptoHashService, PaymentResolveService,
        HotelAuthGuardService,
        HotelService,
        HotelResolverService, LoginGuardService,
        SupervisorsService, SupervisorService, SupervisorResolverService,
        ToastrService, GetAddressService, AddInstitutionService, InstitutionsService,
        PaginationService,
        ParkingsService, ParkingResolverService,
        TownHallsService, FinesService,
        SettingsListService, FineResolverService, ProductsService,
        ParkingResolverService,
        VehicleCheckResolverService,
        SensorHistoryResolverService, ReservationsService,
        ClusterManager
    ],
    entryComponents: [
        CheckPlateComponent,
        DynamicMapComponent
    ],

    bootstrap: [AppComponent]
})
export class AppModule { }
